import React from 'react'
import { useGLTF } from '@react-three/drei'

export function Model({ attachmentRefs = {}, ...props }) {
  const { nodes, materials } = useGLTF('/models/Artemis_SLS_Spinny.glb')
  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Fairing"
          castShadow
          receiveShadow
          geometry={nodes.Fairing.geometry}
          material={materials.M_LAS_Fairing_Details}
        />
        <mesh
          name="Greebles"
          castShadow
          receiveShadow
          geometry={nodes.Greebles.geometry}
          material={materials.M_LAS_Fairing_Details}
        />
        <mesh
          name="LAS"
          castShadow
          receiveShadow
          geometry={nodes.LAS.geometry}
          material={materials.M_LAS_Fairing_Details}
        />
        <mesh
          name="SMClasp"
          castShadow
          receiveShadow
          geometry={nodes.SMClasp.geometry}
          material={materials.M_LAS_Fairing_Details}
        />
        <mesh
          name="SMReduced"
          castShadow
          receiveShadow
          geometry={nodes.SMReduced.geometry}
          material={materials.M_LAS_Fairing_Details}
        />
        <mesh
          name="Boosters"
          castShadow
          receiveShadow
          geometry={nodes.Boosters.geometry}
          material={materials.M_Boosters}
        />
        <mesh
          name="CoreStage"
          castShadow
          receiveShadow
          geometry={nodes.CoreStage.geometry}
          material={materials.M_Core_Stage}
          position={[0, 0, -36.653]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <group ref={attachmentRefs.RS25Engine}          name="RS-25_Engine"                    position={[0, 0, -37.124]}       scale={171.838} />
        <group ref={attachmentRefs.LiquidHydrogen}      name="Liquid_Hydrogen"                 position={[0, 0, -19.421]}       scale={171.838} />
        <group ref={attachmentRefs.CoreStage}           name="Core_Stage"                      position={[0, 0, -0.872]}        scale={171.838} />
        <group ref={attachmentRefs.SolidRocketBoosters} name="Solid_Rocket_Boosters"           position={[6.622, 0, -9.755]}    scale={171.838} />
        <group ref={attachmentRefs.LiquidOxygen}        name="Liquid_Oxygen"                   position={[0, 0, 17.939]}        scale={171.838} />
        <group ref={attachmentRefs.LVSA}                name="Launch_Vehicle_Stage_Adapter"    position={[0, 0, 30.0]}          scale={171.838} />
        {/* ICPS anchor — empty marker group between the LVSA and the (raised) Orion
            capsule on the spine. No mesh of its own; the hotspot points here. */}
        <group ref={attachmentRefs.ICPS}                name="ICPS"                            position={[0, 0, 38.0]}          scale={171.838} />
        <group ref={attachmentRefs.OrionMPCV}           name="Orion_MPCV"                      position={[0, 0, 46.0]}          scale={171.838} />
        <group ref={attachmentRefs.LaunchAbortSystem}   name="Launch_Abort_System"             position={[0, 0, 56.0]}          scale={171.838} />
      </group>
    </group>
  )
}
